<template>

  <form-group :groupClass="groupClass"
              :for-id="id" :label="label" :required="required"
              :validation-errors="validation?.$errors">
    <select :id="id"
            :name="name"
            class="form-control form-select"
            :required="required"
            @change="updateValue($event)">
      <!-- @input="updateValue($event)"
       @keyup="updateValue($event)"-->
      <option v-for="(item,i) in options"
              :value="item.key"
              :selected="item.key===modelValue"
              :disabled="item.disabled">
        {{ item.label }}
      </option>
    </select>
  </form-group>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import FormGroup from '@/components/ui/FormGroup.vue';
import { ErrorObject } from '@vuelidate/core';

export interface OptionItem {
  key: string | number;
  label: string;
  disabled?: boolean;
}

export default defineComponent({
  name: 'GroupSelect',
  components: { FormGroup },
  emits: ['update:modelValue'],
  props: {
    id: String,
    name: String,
    modelValue: String,
    options: Object as PropType<OptionItem[]>,
    required: { type: Boolean, default: false },
    label: String,
    validation: { type: Object as PropType<{ $errors: ErrorObject[] }>, default: null },
    groupClass: { type: String, default: 'mb-3' }
  },
  methods: {
    updateValue(e: Event) {
      this.$emit('update:modelValue', (<HTMLSelectElement>e.target).value);
    }
  },
});
</script>

<style scoped>
</style>
